import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "./Navbar";
import { Panel } from "primereact/panel";
import { useRef } from "react";
import {
  FaChevronDown,
  FaMapMarkerAlt,
  FaBriefcase,
  FaClock,
  FaUsers,
  FaRocket,
  FaHeart,
  FaBalanceScale,
  FaGift,
} from "react-icons/fa";
import PanelComponent from "./components/PanelComponent";
import Footer from "./footer";
import careersBg from "../../assets/images/careers-bg.png";
// import dotenv from 'dotenv';
// dotenv.config();

const Careers = () => {
  const [jobRoles, setJobRoles] = useState([]);
  const [jobRoleCollection, setJobRoleCollection] = useState([]);
  const [displayApplication, setDisplayApplication] = useState(false);
  const [jobApplication, setJobApplication] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    resume: "",
  });
  const [resume, setResume] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const refs = useRef([]);
  const careersRef = useRef(null);

  useEffect(() => {
    getJobs();
  }, []);

  const getJobs = () => {
    // const api_url = process.env.API_URL;
    axios
      .get(`https://admin.smartica.co.in/api/careers-pages?_sort=id:DESC`)
      .then((response) => {
        setJobRoles(response.data.data);
        afterGetData(response.data.data);
      });
  };

  useEffect(() => {
    if (refs.current.length !== jobRoles.length) {
      refs.current = Array(jobRoles.length)
        .fill()
        .map((_, i) => refs.current[i] || React.createRef());
    }
  }, [jobRoles]);

  const afterGetData = (jobs) => {
    let sections = [];
    let department = "";
    let collection = [];
    jobs.forEach((role) => {
      if (
        department !== role.attributes.department &&
        !sections.includes(role.attributes.department)
      ) {
        department = role.attributes.department;
        sections.push(department);
      }
    });
    sections.forEach((eachSection) => {
      collection.push(
        jobs.filter((role) => role.attributes.department === eachSection)
      );
    });
    setJobRoleCollection(collection);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setJobApplication({
        ...jobApplication,
        resume: reader.result.split(",")[1],
      });
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async () => {
    // Validate form
    if (
      !jobApplication.firstName ||
      !jobApplication.lastName ||
      !jobApplication.email ||
      !jobApplication.phone ||
      !jobApplication.resume
    ) {
      setSubmitError("Please fill in all required fields");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(jobApplication.email)) {
      setSubmitError("Please enter a valid email address");
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");

    const sourceData = {
      recipient: "mhdhassimcr717@gmail.com",
      sender: "admin@smartica.co.in",
      subject: "Smartica - Candidate Job Application",
      body: `<p>Candidate <strong>${jobApplication.firstName} ${jobApplication.lastName}&nbsp;</strong>has submitted a Job Application.<br /><br /></p><p>email: ${jobApplication.email}</p><p>Phone: ${jobApplication.phone}</p><p></p><p>Thank You,&nbsp;</p><p><strong>Smartica</strong></p><p><strong></strong></p><p><strong></strong></p>`,
      attachment: jobApplication.resume,
    };

    try {
      await axios.post(
        "https://us-east4-smartica-production.cloudfunctions.net/email-service",
        sourceData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setSubmitSuccess(true);
      setJobApplication({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        resume: "",
      });

      // Close modal after 3 seconds
      setTimeout(() => {
        setDisplayApplication(false);
        setSubmitSuccess(false);
      }, 3000);
    } catch (error) {
      console.error("Error sending email:", error);
      setSubmitError(
        "Failed to submit application. Please try again or contact us directly."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <Navbar />
      {!jobRoles.length ? (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
          <div className="text-center">
            <div className="relative">
              <div className="w-16 h-16 border-4 border-gray-200 rounded-full animate-spin border-t-brand"></div>
              <div className="absolute inset-0 w-16 h-16 border-4 border-transparent rounded-full animate-ping border-t-brand/30"></div>
            </div>
            <h3 className="mt-6 text-xl font-semibold text-gray-900">
              Loading Opportunities
            </h3>
            <p className="mt-2 text-gray-600">
              Finding the perfect positions for you...
            </p>
          </div>
        </div>
      ) : (
        <div>
          {/* Modern Hero Section */}
          <div
            className="relative w-full min-h-screen bg-cover bg-center bg-no-repeat flex items-center"
            style={{ backgroundImage: `url(${careersBg})` }}
          >
            {/* Overlay with gradient */}
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>

            {/* Content */}
            <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 py-20">
              <div className="max-w-4xl">
                {/* Main heading with animation */}
                <div className="animate-fade-in-up mb-8">
                  <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
                    Join Our
                    <span className="block text-transparent bg-clip-text bg-gradient-to-r from-brand to-accent-400">
                      Dream Team
                    </span>
                  </h1>
                  <p className="text-xl sm:text-2xl text-gray-200 leading-relaxed max-w-3xl">
                    Are you ready to take your career to the next level? At
                    SMART Training Resources India Private Limited, we believe
                    that our greatest strength is our people. We're looking for
                    talented, passionate, and driven individuals to join our
                    team and help us shape the future.
                  </p>
                </div>

                {/* Benefits grid with icons */}
                <div className="animate-fade-in-up mb-12">
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                    <div className="flex items-center space-x-3 text-white group">
                      <div className="flex-shrink-0 w-12 h-12 bg-brand/20 rounded-lg flex items-center justify-center group-hover:bg-brand/30 transition-colors">
                        <FaRocket className="text-brand text-xl" />
                      </div>
                      <span className="text-lg font-medium">
                        Innovative Work Environment
                      </span>
                    </div>
                    <div className="flex items-center space-x-3 text-white group">
                      <div className="flex-shrink-0 w-12 h-12 bg-brand/20 rounded-lg flex items-center justify-center group-hover:bg-brand/30 transition-colors">
                        <FaUsers className="text-brand text-xl" />
                      </div>
                      <span className="text-lg font-medium">
                        Empowering Growth
                      </span>
                    </div>
                    <div className="flex items-center space-x-3 text-white group">
                      <div className="flex-shrink-0 w-12 h-12 bg-brand/20 rounded-lg flex items-center justify-center group-hover:bg-brand/30 transition-colors">
                        <FaHeart className="text-brand text-xl" />
                      </div>
                      <span className="text-lg font-medium">
                        Inclusive Culture
                      </span>
                    </div>
                    <div className="flex items-center space-x-3 text-white group">
                      <div className="flex-shrink-0 w-12 h-12 bg-brand/20 rounded-lg flex items-center justify-center group-hover:bg-brand/30 transition-colors">
                        <FaBalanceScale className="text-brand text-xl" />
                      </div>
                      <span className="text-lg font-medium">
                        Work-Life Balance
                      </span>
                    </div>
                    <div className="flex items-center space-x-3 text-white group">
                      <div className="flex-shrink-0 w-12 h-12 bg-brand/20 rounded-lg flex items-center justify-center group-hover:bg-brand/30 transition-colors">
                        <FaGift className="text-brand text-xl" />
                      </div>
                      <span className="text-lg font-medium">
                        Competitive Benefits
                      </span>
                    </div>
                  </div>
                </div>

                {/* CTA Button */}
                <div className="animate-fade-in-up">
                  <button
                    className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-gradient-to-r from-brand to-primary-600 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 ease-in-out"
                    onClick={() => {
                      careersRef.current.scrollIntoView({
                        behavior: "smooth",
                        inline: "start",
                        block: "start",
                      });
                    }}
                  >
                    <span className="relative z-10">
                      Explore Open Positions
                    </span>
                    <div className="absolute inset-0 bg-gradient-to-r from-primary-600 to-brand rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <FaChevronDown className="ml-2 group-hover:translate-y-1 transition-transform duration-300" />
                  </button>
                </div>
              </div>
            </div>

            {/* Scroll indicator */}
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
              <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
                <div className="w-1 h-3 bg-white/60 rounded-full mt-2 animate-pulse"></div>
              </div>
            </div>
          </div>
          {/* Job Positions Section */}
          <div className="bg-gray-50 py-20" ref={careersRef}>
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              {/* Section Header */}
              <div className="text-center mb-16">
                <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
                  Open Positions
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  Discover exciting career opportunities and join our team of
                  passionate professionals
                </p>
                <div className="w-24 h-1 bg-gradient-to-r from-brand to-primary-600 mx-auto mt-6 rounded-full"></div>
              </div>

              {/* Job Listings */}
              <div className="max-w-6xl mx-auto">
                {jobRoleCollection.map((section, sectionIndex) => (
                  <div className="mb-16" key={sectionIndex}>
                    {/* Department Header */}
                    <div className="bg-white rounded-2xl shadow-lg p-6 mb-8 border-l-4 border-brand">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                        <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 bg-gradient-to-r from-brand to-primary-600 rounded-xl flex items-center justify-center">
                            <FaBriefcase className="text-white text-xl" />
                          </div>
                          <div>
                            <h3 className="text-2xl font-bold text-gray-900">
                              {section[0].attributes.department}
                            </h3>
                            <p className="text-gray-600">Department</p>
                          </div>
                        </div>
                        <div className="mt-4 sm:mt-0">
                          <div className="inline-flex items-center px-4 py-2 bg-brand/10 text-brand rounded-full text-sm font-semibold">
                            <FaUsers className="mr-2" />
                            {section.length} Open Role
                            {section.length > 1 ? "s" : ""}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Job Cards */}
                    <div className="space-y-6">
                      {section.map((job, jobIndex) => (
                        <div
                          key={jobIndex}
                          className="transform transition-all duration-300 hover:scale-[1.02]"
                        >
                          <PanelComponent
                            job={job}
                            setDisplayApplication={setDisplayApplication}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Modern Application Modal */}
          {displayApplication && (
            <div
              className="fixed inset-0 z-50 overflow-y-auto"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-title"
            >
              <div className="flex min-h-screen items-center justify-center p-4">
                {/* Backdrop */}
                <div
                  className="fixed inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
                  onClick={() => setDisplayApplication(false)}
                  aria-hidden="true"
                ></div>

                {/* Modal */}
                <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto modal-scroll">
                  {/* Header */}
                  <div className="sticky top-0 bg-gradient-to-r from-brand to-primary-600 text-white p-6 rounded-t-2xl">
                    <div className="flex items-center justify-between">
                      <div>
                        <h2 id="modal-title" className="text-2xl font-bold">
                          Job Application
                        </h2>
                        <p className="text-white/90 mt-1">
                          Join our team today
                        </p>
                      </div>
                      <button
                        onClick={() => setDisplayApplication(false)}
                        className="text-white/80 hover:text-white transition-colors p-2 hover:bg-white/10 rounded-lg"
                        aria-label="Close modal"
                      >
                        <svg
                          className="w-6 h-6"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>

                  {/* Success/Error Messages */}
                  {submitSuccess && (
                    <div className="mx-6 mt-4 p-4 bg-green-50 border border-green-200 rounded-xl">
                      <div className="flex items-center">
                        <svg
                          className="w-5 h-5 text-green-500 mr-3"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <p className="text-green-800 font-medium">
                          Application submitted successfully! We'll be in touch
                          soon.
                        </p>
                      </div>
                    </div>
                  )}

                  {submitError && (
                    <div className="mx-6 mt-4 p-4 bg-red-50 border border-red-200 rounded-xl">
                      <div className="flex items-center">
                        <svg
                          className="w-5 h-5 text-red-500 mr-3"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <p className="text-red-800 font-medium">
                          {submitError}
                        </p>
                      </div>
                    </div>
                  )}

                  {/* Form */}
                  <div className="p-6">
                    <form
                      className="space-y-6"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit();
                      }}
                    >
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                          <label className="block text-sm font-semibold text-gray-700">
                            First Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="fname"
                            id="fname"
                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-brand focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white form-input"
                            value={jobApplication.firstName}
                            onChange={(e) =>
                              setJobApplication({
                                ...jobApplication,
                                firstName: e.target.value,
                              })
                            }
                            required
                            placeholder="Enter your first name"
                            aria-describedby="fname-error"
                            disabled={isSubmitting}
                          />
                        </div>
                        <div className="space-y-2">
                          <label className="block text-sm font-semibold text-gray-700">
                            Last Name <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="lname"
                            id="lname"
                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-brand focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white form-input"
                            value={jobApplication.lastName}
                            onChange={(e) =>
                              setJobApplication({
                                ...jobApplication,
                                lastName: e.target.value,
                              })
                            }
                            required
                            placeholder="Enter your last name"
                            disabled={isSubmitting}
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                          <label className="block text-sm font-semibold text-gray-700">
                            Email Address{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="email"
                            name="email"
                            id="email"
                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-brand focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white form-input"
                            value={jobApplication.email}
                            onChange={(e) =>
                              setJobApplication({
                                ...jobApplication,
                                email: e.target.value,
                              })
                            }
                            required
                            placeholder="your.email@example.com"
                            disabled={isSubmitting}
                          />
                        </div>
                        <div className="space-y-2">
                          <label className="block text-sm font-semibold text-gray-700">
                            Phone Number <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="tel"
                            name="phone"
                            id="phone"
                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-brand focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white form-input"
                            value={jobApplication.phone}
                            onChange={(e) =>
                              setJobApplication({
                                ...jobApplication,
                                phone: e.target.value,
                              })
                            }
                            required
                            placeholder="+1 (555) 123-4567"
                            disabled={isSubmitting}
                          />
                        </div>
                      </div>

                      <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">
                          Resume/CV <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                          <input
                            type="file"
                            accept=".pdf,.doc,.docx"
                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-brand focus:border-transparent transition-all duration-200 bg-gray-50 focus:bg-white file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-brand file:text-white hover:file:bg-primary-600"
                            onChange={handleFileUpload}
                            disabled={isSubmitting}
                          />
                        </div>
                        <p className="text-sm text-gray-500 mt-1">
                          Accepted formats: PDF, DOC, DOCX (Max 10MB)
                        </p>
                      </div>
                    </form>
                  </div>

                  {/* Footer */}
                  <div className="sticky bottom-0 bg-gray-50 px-6 py-4 rounded-b-2xl border-t border-gray-200">
                    <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">
                      <button
                        type="button"
                        onClick={() => setDisplayApplication(false)}
                        className="px-6 py-3 text-gray-700 bg-white border border-gray-300 rounded-xl hover:bg-gray-50 transition-colors duration-200 font-semibold"
                        disabled={isSubmitting}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="px-8 py-3 bg-gradient-to-r from-brand to-primary-600 text-white rounded-xl hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200 font-semibold disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center"
                      >
                        {isSubmitting ? (
                          <>
                            <svg
                              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Submitting...
                          </>
                        ) : (
                          "Submit Application"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Careers;
